// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3daAy","label":"Category_label__1Su6z","content":"Category_content__35104","header":"Category_header__3-N-B","location":"Category_location__yTfXy"};